// ═══════════════════════════════════════════════════════════════════════════
// publicacionesLegacyShape — publicación CANÓNICA → shape legacy mlPublicaciones
// ───────────────────────────────────────────────────────────────────────────
// Bloque 7.6/7.7 — mapeo de borde único para todos los consumidores que
// todavía leen el shape legacy (dashboards en transición + clasificadores).
// Unión de campos auditada (4-jun): id/itemId/title/price/originalPrice/
// permalink/status/availableQuantity/thumbnail/dealIds/_visitas/_visitas30d.
//
// `dealIds`: Wave C C6c — ahora se derivan de `facetas.enPromo` (faceta server
// canónica, started only, ML-validada) en vez del cruce legacy con
// mlPublicacionesPromos. El param `promoIdsActivas` queda DEPRECADO (ignorado);
// los callers pueden dejar de leer mlPublicacionesPromos. DIVERGENCIA declarada:
// started only (el cruce legacy contaba candidatas).
//
// Se borra junto con el retiro del legacy (Bloque 9).
// ═══════════════════════════════════════════════════════════════════════════

// Inverso biyectivo de publicacionesShape.normalizarEstado (los clasificadores
// y dashboards legacy filtran duro por valores raw ML, ej. `status === 'active'`).
export const ESTADO_PUB_A_RAW = {
  activa: 'active', pausada: 'paused', finalizada: 'closed', en_revision: 'under_review',
}

export function pubCanonicaALegacy(p, _promoIdsActivasDeprecado = null) {
  const last30 = p?.datosCanal?.visitasRecientes?.last30 ?? 0
  return {
    id: p.externalId ?? p.id,
    itemId: p.externalId ?? null,
    title: p.titulo ?? null,
    price: p.precio ?? null,
    originalPrice: p.precioOriginal ?? null,
    permalink: p.urlPublica ?? null,
    status: ESTADO_PUB_A_RAW[p.estado] ?? p.estado ?? null,
    availableQuantity: p.stockDisponible ?? null,
    available_quantity: p.stockDisponible ?? null,
    thumbnail: p.imagenPrincipal ?? null,
    dealIds: p?.facetas?.enPromo === true ? ['promo-activa'] : [],
    _visitas: { total: last30 },
    _visitas30d: last30,
    // Extras que algunos dashboards muestran (logística del item, SKU/EAN).
    logisticType: p.datosCanal?.shipping?.logisticType ?? null,
    sellerSku: p.sku ?? null,
    // 15-jul-2026 — Rentabilidad inferida: sku/ean visibles para auditar el
    // match del seed (EAN exacto > SKU exacto; caso compatibilidad de repuestos).
    ean: p.ean ?? null,
    // Wave D (D5, 6-jun-2026): rollups derivados canónicos expuestos con el
    // nombre legacy — los consumidores (Matriz/Evolución/Publicidad/Full y
    // libs puras evaluarElegibilidadPromo/benchmarks) leen `_rentabilidadInferida`
    // / `_costoAdquisicionInferido` / `_fullStock` sin tocar su código.
    // OJO: sin este mapeo el campo llega undefined y los números divergen
    // (así estaba ROTO el filtro "Pausar por rentabilidad" de Publicidad).
    _rentabilidadInferida: p.rentabilidadInferida ?? null,
    _costoAdquisicionInferido: p.costoAdquisicionInferido ?? null,
    _fullStock: p.fullStock ?? null,
    // 11-jul-2026 — Detección de tareas Publicaciones: el clasificador lee
    // salud/tags/cuotas/categoría del sub-doc canónico tal cual (mismas
    // reglas que detectarMetricas de la página). Passthrough, sin re-mapear.
    datosCanal: p.datosCanal ?? null,
    facetas: p.facetas ?? null,
    userProductId: p.userProductId ?? null,
  }
}

// Set de itemIds con promo activa, derivado de mlPublicacionesPromos
// (mismo criterio que PublicacionesPage).
export function promoIdsDe(promosItems) {
  const s = new Set()
  for (const p of (promosItems || [])) {
    const arr = Array.isArray(p?.promociones) ? p.promociones : []
    if (arr.length === 0) continue
    if (p?.itemId) s.add(p.itemId)
    if (p?.id && /^MLA\d+$/.test(p.id)) s.add(p.id)
  }
  return s
}
